module.exports = __webpack_public_path__ + "img/open-in-new.165930c3.svg";